export interface ICarouselResourceStrings {
    igx_carousel_of?: string;
}

export const CarouselResourceStringsEN: ICarouselResourceStrings = {
    igx_carousel_of: 'of'
};
